// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ETPf1","boxWrapper":"styles_boxWrapper__mwlI3","showToolTip":"styles_showToolTip__OS6zc"};